export const sessionTimeout = 60; // Session time - how long since last vote we consider to be the same session
export const locationDataFetchDelay = 3; // Session time - how long since last vote we consider to be the same session

// CFG-STREAK-WEB-1 / D-2 (a) rename-only: `streakLength` was NEVER the streak-interrupt
// cadence — it had zero importers and only fed `countEvents`. Its "how frequently interrupt
// user with asks" comment was false. The cadence now lives in config (`streak.milestones` /
// `streak.repeatEveryVotes`, read in `streakLogic.js`); what is left here is purely the feed
// batch size, renamed off "streak" so the no-cadence-literal grep-guard is checkable.
// `longStreak` was dead (zero importers) and removed with it. Shipped values unchanged (22 / 2).
// Migrating these two to config is deliberately NOT done here — see D-2 in the backlog.
export const minEvents = 2;      // when to start requesting new batch of events
export const feedBatchSize = 22; // how many events to ask at once
export const countEvents = feedBatchSize;


export const notificationDelayMinutes = 2; // 23 * 60;   // delay before next notification in minutes
export const allowReminders = false; //quick way to disable reminders


export const googleMapEdit = 'https://www.google.com/maps/d/edit?mid=16Dj2WqH14OicMgNnkZ1wG0NSJaQIGtU&ll=34.22406542202393%2C-117.6675815779873&z=19';
export const googleMapKML = 'https://www.google.com/maps/d/kml?mid=16Dj2WqH14OicMgNnkZ1wG0NSJaQIGtU';

// Cloud function URLs
// NOTE: sharedEventsUrl is FROZEN — the Dust app parses this URL. Do not change it.
export const sharedEventsUrl = 'https://get-shared-events-fzjaqefbta-uc.a.run.app';
// functionsBaseUrl removed — use BASE_URL from v2Api.js instead (ARC-12).